import { pascalToSnakeCase, snakeToTitleCase } from '@domain-group/javascript-utils'

import type { ActivityModel } from '@models/types'

export const activityKeys = [
  { key: 'artwork.deleted' },
  { key: 'artwork.downloaded' },
  { key: 'artwork.shared' },
  { key: 'artwork.synced_page' },
  { key: 'artwork.updated' },
  { key: 'artwork.uploaded' },
  { key: 'asset_library.created' },
  { key: 'asset_library.deleted' },
  { key: 'asset_library.updated' },
  { key: 'booking.accepted' },
  { key: 'booking.approved' },
  { key: 'booking.completed' },
  { key: 'booking.created' },
  { key: 'booking.deleted' },
  { key: 'booking.dispatched' },
  { key: 'booking.duplicated' },
  { key: 'booking.updated' },
  { key: 'campaign_item.reconciled' },
  { key: 'campaign_item.updated' },
  { key: 'campaign.created' },
  { key: 'campaign.updated' },
  { key: 'campaign_contribution.created' },
  { key: 'conversation.started' },
  { key: 'document_group.authorized' },
  { key: 'finance_application.approved' },
  { key: 'finance_application.declined' },
  { key: 'finance_application.deleted' },
  { key: 'image.deleted' },
  { key: 'image.uploaded' },
  { key: 'image_library.created' },
  { key: 'image_library.deleted' },
  { key: 'image_library.updated' },
  { key: 'invoice.approved' },
  { key: 'invoice.created' },
  { key: 'invoice.created_from_quote' },
  { key: 'invoice.deleted' },
  { key: 'invoice.updated' },
  { key: 'invoice.voided' },
  { key: 'credit_note.created' },
  { key: 'credit_note.deleted' },
  { key: 'credit_note.updated' },
  { key: 'credit_note_item.created' },
  { key: 'order.approved' },
  { key: 'order.approved_pagination' },
  { key: 'order.created' },
  { key: 'order.deleted' },
  { key: 'order.reconciled' },
  { key: 'order.total_overridden' },
  { key: 'order.unapproved' },
  { key: 'order.unapproved_pagination' },
  { key: 'order_item.approved' },
  { key: 'order_item.assigned_artwork' },
  { key: 'order_item.confirmed' },
  { key: 'order_item.deleted' },
  { key: 'order_item.unapproved' },
  { key: 'order_item.updated' },
  { key: 'order_item.updated_status' },
  { key: 'publication_order.booked' },
  { key: 'publication_order.reverted' },
  { key: 'quote.approved_by' },
  { key: 'quote.authorized' },
  { key: 'quote.created' },
  { key: 'quote.deleted' },
  { key: 'quote.updated' },
  { key: 'quote.voided' },
  { key: 'quote_item.created' },
  { key: 'quote_item.updated' },
  { key: 'task.approved' },
  { key: 'task.completed' },
  { key: 'task.deleted' },
  { key: 'task.unapproved' },
  { key: 'task.updated' },
  { key: 'task_list_item.completed' },
  { key: 'task_list_item.reverted' },
  { key: 'template_page.qc_approved' },
  { key: 'template_page.updated' },
  { key: 'template_page_item.created' },
  { key: 'template_page_item.updated' },
  { key: 'template_page_partial.updated' },
  { key: 'user.agency_login' },
  { key: 'user.login_as' },
  { key: 'user.switch_back' },
  { key: 'user_verification.submitted' },
  { key: 'user_verification.verified' },
]

export const destructiveActions = [
  'archived',
  'deleted',
  'failed',
  'removed',
  'reverted',
  'unapproved',
  'unassigned',
]

// Match the names used in the statement history: uploaded (debtor) invoices are Bills, contributions are Payments
const getEntityLabel = (activity: ActivityModel, subject: string) => {
  const createdBy = (activity.parameters as { created_by?: string } | undefined)?.created_by

  if (subject === 'invoice' && createdBy === 'debtor') return 'Bill'
  if (subject === 'campaign_contribution') return 'Payment'

  return snakeToTitleCase(subject)
}

export const renderActionText = (activity: ActivityModel) => {
  const { key, parameters = {} as ActivityModel['parameters'], recipient_type } = activity

  if (recipient_type === 'ProviderPriceList' && parameters?.deleted){
    const { entity_id, entity_type = '' } = parameters || {}
    const entityType = snakeToTitleCase(pascalToSnakeCase(entity_type))

    return `${entityType} # ${entity_id} Deleted`
  }

  if (key){
    const [subject, action] = key.split('.')
    return `${getEntityLabel(activity, subject)} ${snakeToTitleCase(action)}`
  }

  return undefined
}
